import styled from 'styled-components'
import Typography from '@signal/components/Typography'
import TypographySkeleton from '@signal/components/Skeleton/Typography'

export const Wrapper = styled.div``

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Timestamp = styled(Typography).attrs(() => ({
  variant: 'body2'
}))``

export const TimestampSkeleton = styled(
  Timestamp.withComponent(TypographySkeleton)
).attrs(() => ({
  width: 90
}))``
